<template>
  <img :src="src" :class="$style.thumbnail" alt="プランナーのサムネイル画像" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'
import type { FlexImage } from '@/libs/utilities/FlexImage'
import DefaultAvatar from '@/assets/images/no-image-planner.png'

export default defineComponent({
  name: 'PlannerThumbnail',
  props: {
    image: {
      type: Object as PropType<Maybe<FlexImage>>,
      default: undefined,
    },
    width: {
      type: Number,
      default: 80,
    },
    height: {
      type: Number,
      default: 80,
    },
  },
  setup(props) {
    const src = computed((): string => {
      if (props.image === undefined) {
        return DefaultAvatar
      }
      return props.image
        .size({ width: props.width, height: props.height })
        .extension('jpg')
        .toFacefitUrlString()
    })

    return { src }
  },
})
</script>

<style lang="scss" module>
.thumbnail {
  overflow: hidden;
  border-radius: 999em;
  object-fit: contain;
}
</style>
